export default defineNuxtRouteMiddleware((to: any, from: any) => {
  const { isAuthenticated } = storeToRefs(useAuthStore());
  const casinoStore = useCasinoStore();
  const { getRouteBaseName } = useRoutes();

  const routeFromName = getRouteBaseName(from);

  if (to.name === from.name) {
    return;
  }

  if (isAuthenticated.value) {
    if (routeFromName === 'games-provider-game') {
      const { updateWallet } = useWallet();

      updateWallet();
    }
  }

  casinoStore.authModalGames = {
    open: false,
    slug: '',
    title: '',
    subtitle: '',
    image: '',
  };
});
